<template>
  <div>
    <h2 class="bg-green-500 py-3 px-5 text-white mb-8">
      Step 3: Professional References (1 of 2)
    </h2>
    <p>Please provide contact information for two individuals who can confirm your qualifications, experience, and accomplishments.</p>
    <h3>General Info</h3>
    <form @submit.prevent="goToNextPage">
      <div class="flex flex-wrap -mx-5 mb-4 md:mb-0">
        <d-field label="First Name" class="w-full md:w-1/2 px-5">
          <d-input v-model="referenceFirstName" aria-label="first name" required />
        </d-field>
        <d-field label="Last Name" class="w-full md:w-1/2 px-5">
          <d-input v-model="referenceLastName" aria-label="last name" required />
        </d-field>
      </div>
      <d-field label="Title / Position">
        <d-input v-model="referenceTitlePosition" aria-label="title position" required />
      </d-field>

      <h3>Address Info</h3>
      <d-field label="Address Line 1">
        <d-input v-model="referenceAddressLineOne" aria-label="address line one" placeholder="Street Address" required />
      </d-field>
      <d-field label="Address Line 2">
        <d-input v-model="referenceAddressLineTwo" aria-label="address line two" placeholder="suite, apt. or box #" />
      </d-field>

      <div class="flex flex-wrap -mx-5 mb-4 md:mb-0">
        <d-field label="Country" class="w-full md:w-1/2 px-5">
          <d-select v-model="referenceCountry" expanded required>
            <option value="" disabled>
              Select a Country
            </option>
            <option v-for="country in countryOptions" :key="country.name" :value="country.name">
              {{ country.name }}
            </option>
          </d-select>
        </d-field>
        <d-field label="State/Province" class="w-full md:w-1/2 px-5">
          <d-select v-model="referenceState" expanded required>
            <option value="" disabled>
              Select a State
            </option>
            <option v-for="state in availableStateOptions" :key="state.name" :value="state.abbreviation">
              {{ state.name }}
            </option>
          </d-select>
        </d-field>
      </div>

      <div class="flex flex-wrap -mx-5 mb-4 md:mb-0">
        <d-field label="City" class="w-full md:w-1/2 px-5">
          <d-input v-model="referenceCity" aria-label="City" required />
        </d-field>
        <d-field label="Zip/Postal" class="w-full md:w-1/2 px-5">
          <d-input v-model="referenceZipCode" aria-label="Zip/postal code" required />
        </d-field>
      </div>

      <h3>Contact Info</h3>
      <d-field label="Email Address">
        <d-input v-model="referenceEmailAddress" aria-label="Email" type="email" required />
      </d-field>
      <div class="flex flex-wrap -mx-5 mb-4 md:mb-0">
        <d-field label="Phone" class="w-full md:w-1/2 px-5">
          <d-input v-model="referencePhone" aria-label="Phone number" required />
        </d-field>
        <d-field label="Fax" class="w-full md:w-1/2 px-5">
          <d-input v-model="referenceFax" aria-label="Fax number" />
        </d-field>
      </div>
      <div class="flex flex-wrap justify-center md:justify-end pt-5">
        <d-btn class="mx-5" @click="goToPrevPage">
          Prev <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
        <d-btn type="submit" class="mx-5 md:mx-0">
          Next <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
      </div>
    </form>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import { mapFields } from '../../../../Resources/scripts/utilities/field.utilities';
  import { DRAFTING_ACCREDITION_FORM } from '../../../../Resources/scripts/store/mutation-types';

  const { mapActions, mapGetters } = createNamespacedHelpers('draftingAccreditionForm');

  export default {
    computed: {
      ...mapFields({
        fields: ['referenceFirstName', 'referenceLastName', 'referenceTitlePosition', 'referenceCountry', 'referenceAddressLineOne', 'referenceAddressLineTwo', 'referenceCity', 'referenceState', 'referenceZipCode', 'referenceEmailAddress', 'referencePhone', 'referenceFax'],
        module: 'draftingAccreditionForm',
        base: 'formFields',
        mutation: DRAFTING_ACCREDITION_FORM.FORM_FIELDS,
      }),

      ...mapGetters([
        'countryOptions',
        'stateProvinceOptions',
      ]),

      availableStateOptions() {
        return this.stateProvinceOptions(this.referenceCountry);
      },
    },

    watch: {
      referenceCountry() {
        this.referenceState = '';
      },
    },

    methods: {
      ...mapActions([
        'goToPrevPage',
        'goToNextPage',
      ]),
    },
  };
</script>